module.exports = __webpack_public_path__ + "static/media/FFEP_230516.e587bfaa.jpg";